// @ts-nocheck
import base from "./base"

export default (store, credentials) => {
  return base(store, {
    data: { credentials },
    methods: {
      open_files: store.open,
      open_folders: store.open,
      refresh() {
        this.populate()
      },
    },
  })
}
